var map = {
	"./1984.jpg": 6379,
	"./a-psalm-for-the-wild-built.jpg": 5941,
	"./at-night-all-blood-is-black.jpg": 2735,
	"./cand-nu-mai-intelegem-lumea.jpg": 5769,
	"./capitalist-realism.jpg": 5321,
	"./cloud-cuckoo-land.jpg": 5774,
	"./ereticii-dunei.jpg": 302,
	"./feminism-is-for-everybody.jpg": 2685,
	"./flatland.jpg": 6446,
	"./forgiveness-parade.jpg": 9097,
	"./frog-and-toad-are-friends.jpg": 3597,
	"./gaza-in-crisis.jpg": 2344,
	"./giovanni-s-room.jpg": 1452,
	"./hearstopper-volume-one.jpg": 5899,
	"./heartstopper-volume-two.jpg": 5260,
	"./how-to-spot-a-fascist.jpg": 3248,
	"./maurice.jpg": 7833,
	"./my-life-has-stood-a-loaded-gun.jpg": 5061,
	"./night-sky-with-exit-wounds.jpg": 2435,
	"./oameni-anxiosi.jpg": 3032,
	"./of-mice-and-men.jpg": 815,
	"./on-palestine.jpg": 4582,
	"./one-hundred-years-of-solitude.jpg": 5032,
	"./poarta-ti-plugul-peste-oasele-mortilor.jpg": 2722,
	"./poveste-de-craciun.jpg": 9843,
	"./povestiri-bizare.jpg": 8742,
	"./profit-over-people.jpg": 979,
	"./readings-from-the-book-of-exile.jpg": 1822,
	"./songs-of-innocence-and-of-experience.jpg": 3005,
	"./swimming-in-the-dark.jpg": 887,
	"./the-complete-stories.jpg": 8907,
	"./the-endarkenment.jpg": 2674,
	"./the-fire-next-time.jpg": 6221,
	"./the-giving-tree.jpg": 6107,
	"./the-heart-is-a-lonely-hunter.jpg": 5800,
	"./the-new-age-of-empire.jpg": 2895,
	"./the-principles-of-communism.jpg": 779,
	"./the-prophet.jpg": 7124,
	"./the-song-of-achilles.jpg": 4725,
	"./the-will-to-change.jpg": 5341,
	"./un-veac-de-singuratate.jpg": 9011,
	"./why-socialism.jpg": 1389,
	"./wise-blood.jpg": 454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1182;